<template>
  <div class="row">
    <div class="col p-0 m-0 hero-holder">
      <img :src="banner.heroImage" :alt="banner.heroImageAltText" aria-hidden="true" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Hero",
  props: {
    banner: Object,
  },
  // Image swapping for mobile and desktop not needed
  // data() {
  //   return {
  //     isMobile: false,
  //     matchMedia: null,
  //   };
  // },
  // created() {
  //   this.matchMedia = window.matchMedia("(max-width: 768px)");
  //   this.matchMedia.addListener(this.handleMediaChange);
  //   this.handleMediaChange(this.matchMedia);
  // },
  // destroyed() {
  //   this.matchMedia.removeListener(this.handleMediaChange);
  // },
  // methods: {
  //   handleMediaChange(mediaQuery) {
  //     this.isMobile = mediaQuery.matches;
  //   },
  // },
};
</script>
<style lang="scss" scoped>
.hero-holder {
  font-family: var(--micrositeTypeStyle);

  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
  }
}
</style>
